<template>
  <div class="activities">
    <div class="title">
      <div></div>
      系统设置
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>

        <el-table-column align="center" prop="" label="会员费用">
          <template slot-scope="scope">
            {{ "￥" + scope.row.vipFee }}
          </template>
        </el-table-column>

        <el-table-column align="center" prop="" label="开通会员前图片">
          <template slot-scope="images">
            <el-image
              style="width: 50px; height: 50px"
              class="table-td-thumb"
              :src="images.row.vipPageBefore"
              :preview-src-list="[images.row.vipPageBefore]"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="" label="开通会员后图片">
          <template slot-scope="images">
            <el-image
              style="width: 50px; height: 50px"
              class="table-td-thumb"
              :src="images.row.vipPageAfter"
              :preview-src-list="[images.row.vipPageAfter]"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="update(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="title" style="margin: 20px 0">
        <div></div>
        视频设置
      </div>
      <div class="videos">
        <span> 会员视频：</span>
        <div>
          <video
            v-if="vipVideo"
            ref="video"
            :src="vipVideo"
            :autoplay="videolist.autoplay"
            :controls="videolist.controls"
            :controlslist="videolist.controlslist"
            :webkit-playsinline="webkitplaysinline"
            style="width: 200px; height: 200px"
          ></video>
          <el-upload
            class="avatar-uploader"
            :action="imgURL"
            :show-file-list="false"
            :on-success="vipClick"
             :on-progress="progress"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
      </div>
      <div class="videos" style="margin-top: 20px">
        <span> 商家视频：</span>
        <div>
          <video
            v-if="barVideo"
            ref="video"
            :src="barVideo"
            :autoplay="videolist.autoplay"
            :controls="videolist.controls"
            :controlslist="videolist.controlslist"
            :webkit-playsinline="webkitplaysinline"
            style="width: 200px; height: 200px"
          ></video>
          <el-upload
            class="avatar-uploader"
            :action="imgURL"
            :show-file-list="false"
            :on-success="merchantClick"
            :on-progress="progress"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
      </div>
    </div>
    <el-dialog title="编辑信息" :visible.sync="addDialog" width="30%" center>
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="价格" label-width="120px" prop="vipFee">
          <el-input v-model="form.vipFee" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="开通会员前图片" prop="url" label-width="120px">
          <el-upload
            class="avatar-uploader"
            :action="imgURL"
            :show-file-list="false"
            :on-success="handleSuccess"
          >
            <img
              style="width: 100px; height: 100px"
              v-if="form.vipPageBefore"
              :src="form.vipPageBefore"
              class="avatar"
            />
            <i
              style="width: 100px; height: 100px"
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="开通会员后图片" prop="url" label-width="120px">
          <el-upload
            class="avatar-uploader"
            :action="imgURL"
            :show-file-list="false"
            :on-success="vipPageAfterSuccess"
          >
            <img
              style="width: 100px; height: 100px"
              v-if="form.vipPageAfter"
              :src="form.vipPageAfter"
              class="avatar"
            />
            <i
              style="width: 100px; height: 100px"
              v-else
              class="el-icon-plus avatar-uploader-icon"
            ></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="updateS(form.id, form.vipFee)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { IP, sysList, updateSys, uploadVideo, listVideos } from "@/api/api";
export default {
  data() {
    return {
      videolist: {
        autoplay: false, // 自动播放
        controls: "controls", //操作
        controlslist: "nodownload   noplaybackrate",
        /*
        1、nodownload: 不要下载按钮
        2、nofullscreen: 不要全屏按钮
        3、noremoteplayback: 不要远程回放
        4、disablePictureInPicture 不要画中画按钮
        5、noplaybackrate 不要播放速度按钮
        */
      }, //video配置
      webkitplaysinline: "true",

      vipVideo: "",
      barVideo: "",
      // 图片上传地址
      imgURL: IP + "/images/uploadImage",
      tableData: [],
      addDialog: false,
      form: {
        id: "",
        vipFee: "",
        vipPageBefore: "",
        vipPageAfter: "",
      },
      rules: {
        //验证规则
        vipFee: [{ required: true, message: "请输入价格", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getList();
    this.listVideos();
  },
  methods: {
    // 获取视频
    async listVideos() {
      let res = await listVideos();
      res.data.forEach((item) => {
        if (item.videoType == "VIP_VIDEO") {
          this.vipVideo = item.videoUrl;
        } else if (item.videoType == "BAR_VIDEO") {
          this.barVideo = item.videoUrl;
        }
      });
    },
    // 上传会员视频
    async vipClick(url) {
      console.log(url);

      // 视频类型 VIP_VIDEO：会员视频，BAR_VIDEO：商家视频

      let res = await uploadVideo({
        videoType: "VIP_VIDEO",
        videoUrl: url,
      });
      if (res.code == 200) {
        this.loading.close();
        this.listVideos();
        this.$message({
          message: "恭喜你，视频上传成功",
          type: "success",
        });
      }
    },
    // merchantClick 上传商家视频
    async merchantClick(url) {
      console.log(url);

      // 视频类型 VIP_VIDEO：会员视频，BAR_VIDEO：商家视频

      let res = await uploadVideo({
        videoType: "BAR_VIDEO",
        videoUrl: url,
      });
      if (res.code == 200) {
        this.loading.close();
        this.listVideos();
        this.$message({
          message: "恭喜你，视频上传成功",
          type: "success",
        });
      }
    },
    // 上传视频中
    progress() {
      this.loading = this.$loading({
        lock: true,
        text: "上传视频中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    //上传开会员图片前
    handleSuccess(response, file, fileList) {
      console.log(response);
      this.form.vipPageBefore = response;
    },

    // 上传开会员图片后
    vipPageAfterSuccess(e) {
      console.log(e);
      this.form.vipPageAfter = e;
    },

    // xx(){},
    //   zz(){},
    async updateS(id, vipFee) {
      let res = await updateSys({
        id: id,
        vipFee: vipFee,
        vipPageBefore: this.form.vipPageBefore,
        vipPageAfter: this.form.vipPageAfter,
      });
      if (res.code == 200) {
        this.addDialog = false;
        this.$message({
          type: "success",
          message: "修改成功",
        });
        this.getList();
      }
    },

    update(row) {
      this.addDialog = true;
      this.form = { ...row };
      // this.form.id = this.tableData[0].id;
      // this.form.vipFee = this.tableData[0].vipFee;
    },
    //  获取banner列表
    async getList() {
      let res = await sysList({});
      console.log(res);
      let { data } = res;
      this.tableData = data;
    },
  },
};
</script>

<style lang="less" scoped>
.videos {
  display: flex;
}
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>